export function dateValidator(inputDate) {
    // Parse the input date
    const givenDate = new Date(inputDate);
    const today = new Date();
  
    // Set the time of today's date to midnight for an accurate comparison
    today.setHours(0, 0, 0, 0);
  
    // Check if the given date is in the future
    return givenDate <= today;
}

  